import React from 'react';

export type NavTab = 'today' | 'rewards' | 'manage';

interface NavigationProps {
  activeTab: NavTab;
  onChangeTab: (tab: NavTab) => void;
  readyRewardsCount?: number;
}

export const Navigation: React.FC<NavigationProps> = ({
  activeTab,
  onChangeTab,
  readyRewardsCount = 0,
}) => {
  return (
    <nav className="nav-tabs" aria-label="Main Navigation">
      <button
        id="tab-today-btn"
        className={`nav-tab-btn tab-today ${activeTab === 'today' ? 'active' : ''}`}
        onClick={() => onChangeTab('today')}
      >
        <span>📋</span>
        <span>Today</span>
      </button>

      <button
        id="tab-rewards-btn"
        className={`nav-tab-btn tab-rewards ${activeTab === 'rewards' ? 'active' : ''}`}
        onClick={() => onChangeTab('rewards')}
      >
        <span>🎁</span>
        <span>Rewards</span>
        {readyRewardsCount > 0 && (
          <span
            id="badge-rewards-ready"
            className="nav-tab-ready-badge"
            title={`${readyRewardsCount} reward${readyRewardsCount > 1 ? 's' : ''} ready to collect!`}
          >
            {readyRewardsCount}
          </span>
        )}
      </button>

      <button
        id="tab-manage-btn"
        className={`nav-tab-btn tab-manage ${activeTab === 'manage' ? 'active' : ''}`}
        onClick={() => onChangeTab('manage')}
      >
        <span>+</span>
        <span>Manage</span>
      </button>
    </nav>
  );
};
